export default __webpack_public_path__ + "static/media/arrow-red.9a042320.svg";